import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Activity, User } from "lucide-react";

export default function ActivityLog({ projectId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/projects/${projectId}/activity`);
        setItems(data);
      } finally { setLoading(false); }
    })();
  }, [projectId]);

  return (
    <div className="space-y-4">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400">Timeline</div>
        <div className="text-neutral-600 text-sm">{items.length} events logged</div>
      </div>
      {loading ? (
        <div className="text-neutral-500 text-sm">Loading…</div>
      ) : items.length === 0 ? (
        <div className="panel p-8 text-center text-neutral-500 text-sm">No activity yet.</div>
      ) : (
        <div className="relative pl-6">
          <div className="absolute left-[7px] top-1 bottom-1 w-px bg-[#E4E7EC]" />
          {items.map(it => (
            <div key={it.id} className="relative mb-4" data-testid={`activity-${it.id}`}>
              <div className="absolute -left-6 top-1 w-3 h-3 rounded-full bg-gradient-to-br from-orange-500 to-red-500 border-2 border-[#FFFFFF]" />
              <div className="panel p-3">
                <div className="flex items-center gap-2 text-[11px] font-mono text-neutral-600 flex-wrap">
                  <User className="w-3 h-3" />
                  <span className="text-neutral-800">{it.actor_name || "System"}</span>
                  <span className="text-neutral-600">·</span>
                  <span className="text-neutral-500 uppercase">{it.actor_role}</span>
                  <span className="text-neutral-600">·</span>
                  <span className="text-neutral-500">{new Date(it.created_at).toLocaleString()}</span>
                </div>
                <div className="mt-1 text-sm">
                  {it.action}
                  {it.detail && <span className="text-neutral-600 ml-1">— {it.detail}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
